/**
 * @generated SignedSource<<b938889bacf983c42658fef36a5f861a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventDetailYourSignup_event$data = {
  readonly eventSeries: {
    readonly facility: {
      readonly copyOverrides: {
        readonly eventPlayer: {
          readonly singular: string;
        } | null | undefined;
      };
    };
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentSignUp_event">;
  readonly " $fragmentType": "EventDetailYourSignup_event";
};
export type EventDetailYourSignup_event$key = {
  readonly " $data"?: EventDetailYourSignup_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailYourSignup_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailYourSignup_event",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCurrentSignUp_event"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FacilityCopyOverrides",
              "kind": "LinkedField",
              "name": "copyOverrides",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NounOverride",
                  "kind": "LinkedField",
                  "name": "eventPlayer",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "singular",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "d6d74304b454427e9d2647e93745ae37";

export default node;
